import type { IntradayBidRow } from '~/pages/IntradayBidding/models/intradayBidRow'

/**
 * 入札一覧に表示中の札のうち操作の対象になる札と、 絞り込みで表示していない対象の件数
 * (提出 AC-BIN-009・入札を全削除 AC-BIN-138 の確認ダイアログの「対象外」の行)。
 *
 * `allBids` は選択中の受渡日の全札、 `listedBids` は一覧の絞り込み (フィルタと売買逆転のみ表示)
 * を掛けた後の札。 `existingCount` は絞り込む前の対象の件数で、 絞り込みを解除すれば押せるように
 * なるかの判定 (押せない理由の出し分け) に使う。
 */
export function scopeToListedBids(
  allBids: readonly IntradayBidRow[],
  listedBids: readonly IntradayBidRow[],
  isTarget: (bid: IntradayBidRow) => boolean,
): { targets: IntradayBidRow[]; existingCount: number; hiddenCount: number } {
  const targets = listedBids.filter(isTarget)
  const existingCount = allBids.filter(isTarget).length
  return {
    targets,
    existingCount,
    hiddenCount: existingCount - targets.length,
  }
}
